module.exports = __webpack_public_path__ + "static/media/pagination-next-disabled.1b389c4b.svg";